<template>
  <div ref="regalosRef" class="mesa-regalos-section">
    <h2 ref="tituloRef" class="mesa-titulo animate-item">MESA DE<br />REGALOS</h2>
    <p ref="descripcionRef" class="mesa-descripcion animate-item">
      ¡TÚ PRESENCIA EN NUESTRO GRAN DÍA ES EL MEJOR REGALO QUE PODRÍAMOS PEDIR!<br />
      SI DESEAS SORPRENDERNOS, UN SOBRECITO DE AMOR NOS AYUDARÁ A CONSTRUIR JUNTOS NUESTRO FUTURO.
    </p>

    <!-- Carrusel de tarjetas -->
    <div class="mesa-carrusel animate-item" ref="box1Ref">
      <div class="mesa-tarjeta animate-item">
        <p class="mesa-lugar">Alejandra Villarreal</p>
        <p class="mesa-numero">Santander</p>
        <p class="mesa-numero">5579 1004 4346 1924</p>
      </div>
      <div class="mesa-tarjeta animate-item">
        <p class="mesa-lugar">Adolfo Ivan Rodríguez Bugarín</p>
        <p class="mesa-numero">Banamex</p>
        <p class="mesa-numero">5256 7838 8666 6198</p>
      </div>
    </div>

    <img ref="sobreRef" src="@/assets/SOBRE.avif" class="sobre-icono animate-item" alt="Sobre decorativo" />

    <p ref="notaRef" class="nota-extra animate-item">
      Lluvia de sobres el día del evento.
    </p>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'MesaRegalos',
  setup() {
    const regalosRef = ref(null)
    const elementosAnimados = ref([])

    onMounted(() => {
      nextTick(() => {
        elementosAnimados.value = regalosRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = Array.from(elementosAnimados.value).indexOf(entry.target)

                gsap.fromTo(
                  entry.target,
                  { opacity: 0, y: 40, scale: 0.95 },
                  {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 0.8,
                    delay: index * 0.15,
                    ease: 'power2.out',
                  }
                )

                observer.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.3 }
        )

        elementosAnimados.value.forEach((el) => observer.observe(el))
      })
    })

    return {
      regalosRef
    }
  }
}
</script>

<style scoped>
.mesa-regalos-section {
  background-color: #2b2a29;
  color: #f1e9dc;
  font-family: 'Playfair Display', serif;

  text-align: center;
  padding: 60px 20px;
}

.mesa-titulo {
  font-size: 36px;
  font-weight: normal;
  line-height: 1.3;
  margin-bottom: 20px;
}

.mesa-descripcion {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  line-height: 1.8;
  letter-spacing: 1px;
  color: #e2d8cb;
  margin-bottom: 40px;
  text-transform: uppercase;
}

.mesa-box {
  background: transparent;
  border: none;
  margin-bottom: 30px;
}

.mesa-lugar {
  font-family: 'corinthia';
  font-size: 26px;
  color: #e0cba0;
  margin-bottom: 6px;
}

.mesa-numero {
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #f6f2e6;
}

.btn-mesa {
  display: inline-block;
  padding: 7px 20px;
  border: 1px solid #f1e9dc;
  color: #f1e9dc;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  border-radius: 30px;
  text-decoration: none;
  transition: background 0.3s ease;
}

.btn-mesa:hover {
  background: #f1e9dc;
  color: #2b2a29;
}

.sobre-icono {
  width: 90px;
  height: auto;
  margin: 40px 0 20px;
}

.nota-extra {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: #f1e9dc;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* Estado inicial (opcional por si no carga GSAP rápido) */
.animate-item {
  opacity: 0;
  transform: translateY(40px);
}
</style>
